/**
 * Centralized branding configuration
 * Change these values to rebrand the application
 */

const BRANDING = {
  // App name - used throughout the UI
  appName: 'TwentyDocs',
  
  // Short name for compact displays
  appNameShort: 'TwentyDocs',
  
  // Tagline for landing page and marketing
  tagline: 'Document Automation & Workflow Management',
  
  // CRM mode tagline
  crmTagline: 'Family Law Practice Management',
  
  // Support email
  supportEmail: 'support@twentydocs.ai',
  
  // Primary colors (Tailwind classes)
  colors: {
    primary: 'violet',
    primaryGradient: 'from-violet-600 to-indigo-600',
    primaryGradientHover: 'from-violet-700 to-indigo-700',
  },
  
  // Logo configuration
  logo: {
    // Icon to use (Lucide icon name)
    icon: 'FileText',
    // Background gradient
    gradient: 'from-violet-600 to-indigo-600',
  },
  
  // Company info (for footer, legal pages)
  company: {
    name: 'TwentyDocs',
    year: new Date().getFullYear(),
  }
};

export default BRANDING;
